module.exports = {
  LOGGER_REFERENCE_PREFIX: '{{',
  LOGGER_REFERENCE_SUFFIX: '}}',

  BROWSER_DEBUG_COLOR: '#297708',
  BROWSER_INFO_COLOR: '#0098ee',
  BROWSER_WARN_COLOR: '#fed000',
  BROWSER_ERROR_COLOR: '#c30000',
}
